import { lazy } from 'react';

export const Calc = lazy(() => import('./Calc'));
